import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import GalleryService from "../../services/GalleryService";

const EditGallery = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialGalleryState = {
    id: null,
    name: "",
    image: null,
    published: false,
  };
  const [currentGallery, setCurrentGallery] = useState(initialGalleryState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  // const [alert, setAlert] = useState("alert alert-danger");
  // const [image, setImage] = useState(null);

  const getGallery = (id) => {
    GalleryService.get(id)
      .then((response) => {
        setCurrentGallery(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getGallery(id);
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentGallery({ ...currentGallery, [name]: value });
  };

  const handleImageInputChange = (event) => {
    const { name } = event.target;
    const inputimage = event.target.files[0];
    // setImage(inputimage);
    setCurrentGallery({ ...currentGallery, [name]: inputimage });
  };

  // console.log(image)

  const updateGallery = () => {
    GalleryService.update(currentGallery.id, currentGallery)
      .then((response) => {
        setServermessage("The Gallery was updated successfully!");
        setSubmitted(true);
        // console.log(currentGallery)
      })
      .catch((e) => {
        console.log(e.response.data.message);
        setServermessage("Error: " + e.response.data.message);
        setSubmitted(true);
      });
  };

  const deleteGallery = () => {
    GalleryService.remove(currentGallery.id)
      .then((response) => {
        console.log(response.data);
        navigate("/admin/gallery");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <div className="container pb-10">
      {currentGallery ? (
        <>
          <h1 className="text-1xl lg:text-1xl font-semibold py-10">
            {" "}
            Edit {currentGallery.name}
          </h1>
          <div>
            {submitted ? (
              <div
                className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                role="alert"
              >
                <p style={{ marginBottom: "0" }}>{servermessage}</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: "0" }}>{servermessage}</p>
              </>
            )}
            <br></br>
          </div>

          <form className="w-full">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Name
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="name"
                  name="name"
                  type="text"
                  value={currentGallery.name}
                  required
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                  Image
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  type="file"
                  id="image"
                  onChange={handleImageInputChange}
                  name="image"
                />
              </div>
            </div>
          </form>

          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 grid grid-cols-2 gap-40">
              <button
                className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                onClick={deleteGallery}
              >
                Delete
              </button>

              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={updateGallery}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <br />
          <p>Please click on a Gallery...</p>
        </div>
      )}
    </div>
  );
};

export default EditGallery;
